import { Injectable } from '@angular/core';
import { CoreServicesModule } from './core-services.module';

export interface CoreServicesLabels {
  Apr: string;
  Aug: string;
  batteryPercentage: string;
  energyDailyIrradiation: string;
  energyIrradiation: string;
  day: string;
  Dec: string;
  duration: string;
  energy: string;
  energyCharging: string;
  energyConsuming: string;
  energyDischarging: string;
  energyExporting: string;
  energyGenerating: string;
  energyImporting: string;
  fast: string;
  Feb: string;
  fri: string;
  fromBattery: string;
  fromGrid: string;
  fromSolar: string;
  green: string;
  greenMixed: string;
  Jan: string;
  Jul: string;
  Jun: string;
  kilometer: string;
  Mar: string;
  maxTh: string;
  May: string;
  minTh: string;
  mon: string;
  month: string;
  noConnection: string;
  Nov: string;
  Oct: string;
  percentage: string;
  power: string;
  powerCharging: string;
  powerConsuming: string;
  powerDischarging: string;
  powerExporting: string;
  powerGenerating: string;
  powerImporting: string;
  powerState: string;
  sat: string;
  selfConsume: string;
  selfProduction: string;
  Sep: string;
  sessionEnergy: string;
  singleKilometer: string;
  singleTimePower: string;
  strategy: string;
  sun: string;
  thu: string;
  time: string;
  timePower: string;
  toBattery: string;
  toGrid: string;
  toHome: string;
  tue: string;
  value: string;
  wed: string;
  warning: string;
}

export const coreServicesLabels: CoreServicesLabels = {
  Apr: 'Apr',
  Aug: 'Aug',
  batteryPercentage: 'Battery percentage',
  energyDailyIrradiation: 'Daily irradiation',
  energyIrradiation: 'Irradiation',
  day: 'Day',
  Dec: 'Dec',
  duration: 'Duration',
  energy: 'Energy',
  energyCharging: 'Energy charging',
  energyConsuming: 'Energy consuming',
  energyDischarging: 'Energy discharging',
  energyExporting: 'Energy exporting',
  energyGenerating: 'Energy generating',
  energyImporting: 'Energy importing',
  fast: 'Fast',
  Feb: 'Feb',
  fri: 'Fri',
  fromBattery: 'from battery',
  fromGrid:'from grid',
  fromSolar: 'from solar',
  green: 'Green',
  greenMixed: 'Green mixed',
  Jan: 'Jan',
  Jul: 'Jul',
  Jun: 'Jun',
  kilometer: 'Kilometer',
  Mar: 'Mar',
  maxTh: 'Max threshold',
  May: 'May',
  minTh: 'Min threshold',
  mon: 'Mon',
  month: 'Month',
  noConnection: 'No internet connection',
  Nov: 'Nov',
  Oct: 'Oct',
  percentage: 'percentage',
  power: 'power',
  powerCharging: 'Power charging',
  powerConsuming: 'Power consuming',
  powerDischarging: 'Power discharging',
  powerExporting: 'Power exporting',
  powerGenerating: 'Power generating',
  powerImporting: 'Power importing',
  powerState: 'Power state',
  sat: 'Sat',
  selfConsume: 'Selfconsume',
  selfProduction: 'Not injected into grid',
  Sep: 'Sep',
  sessionEnergy: 'Session energy',
  singleKilometer: 'Kilometer',
  singleTimePower: 'Time power',
  strategy: 'strategy',
  sun: 'Sun',
  thu: 'Thu',
  time: 'Time',
  timePower: 'Time power',
  toBattery: 'to battery',
  toGrid:'to grid',
  toHome: 'to home',
  tue: 'Tue',
  value: 'Value',
  wed: 'Wed',
  warning: 'Warning',
};

@Injectable({
  providedIn: CoreServicesModule,
})
export class CoreServicesService {

  get labels(): CoreServicesLabels {
    return coreServicesLabels;
  }

  updateLabels(labels: Partial<CoreServicesLabels>): void {
    Object.assign(coreServicesLabels, labels);
  }
}
